export default __webpack_public_path__ + "static/media/Trial.1ea1736b.png";